import Venue from "../../../../src/components/Home/Venue";
import NextVenImg27 from "../../../../src/images/venue-27/27-04.jpg";
import * as React from 'react';
export default {
  Venue,
  NextVenImg27,
  React
};